<div *ngIf="isFetching" class="progress-bar"></div>
